import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/stylus/main.styl';

import { register } from "./register";
import i18n from './i18n'
Vue.config.ignoredElements = ['wx-open-launch-app']
Vue.config.productionTip = false
register(Vue)
export default new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
